import React from 'react'
import { useTranslation } from 'react-i18next'

import { Tag } from './styled'

interface TrainingTypeTagProps {
  normative: boolean
}

const TrainingTypeTag: React.FC<TrainingTypeTagProps> = ({ normative }) => {
  const { t } = useTranslation()
  const prefix = 'administration.courses.list.create.table.headers.trainingType'

  return (
    <Tag $variant={normative ? 'normative' : 'general'}>
      {t(normative ? `${prefix}.normative` : `${prefix}.general`)}
    </Tag>
  )
}

export default TrainingTypeTag
